import {
  Box,
  Button,
  CircularProgress,
  Stack,
  SxProps,
  useTheme,
} from "@mui/material";
import React from "react";

interface GenericCounterProps {
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange?: (value: number) => void;
  isLoading?: boolean;
  isDisabled?: boolean;

  slot?: {
    wrapper?: {
      sx?: SxProps;
    };
    increment?: {
      sx?: SxProps;
    };
    decrement?: {
      sx?: SxProps;
    };

    value?: {
      sx?: SxProps;
    };
  };
  [key: string]: any; // rest props
}

export function GenericCounter(props: GenericCounterProps) {
  const handleIncrement = () => {
    const next = props.value + (props.step || 1);
    if (props.max !== undefined && next > props.max) return;
    props?.onChange?.(next);
    return next;
  };

  const handleDecrement = () => {
    const next = props.value - (props.step || 1);
    if (props.min !== undefined && next < props.min) return;
    props?.onChange?.(next);
    return next;
  };

  const theme = useTheme();
  return (
    <Stack direction={"row"} sx={{ ...props?.slot?.wrapper?.sx }}>
      <Button
        disabled={
          props?.isDisabled || props?.isLoading || props.value <= props.min
        }
        onClick={handleDecrement}
        variant="contained"
        sx={{
          minWidth: "unset",
          width: "40px",
          height: "32px",
          borderRadius: "4px 0 0 4px",
          fontSize: "1.2rem",
          "&:hover": {
            outline: "none",
          },
          "&.Mui-disabled": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.getContrastText(theme.palette.primary.main),
            opacity: 0.5,
          },
          ...props?.slot?.decrement?.sx,
        }}
      >
        -
      </Button>
      <Box
        sx={{
          minWidth: "40px",
          minHeight: "32px",
          width: "40px",
          height: "32px",
          lineHeight: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: `1px solid ${theme.palette.divider}`,
          borderLeft: "none",
          borderRight: "none",
          userSelect: "none",
          color: props?.isDisabled
            ? theme.palette.text.disabled
            : theme.palette.text.primary,
          ...props?.slot?.value?.sx,
        }}
      >
        {props?.isLoading ? <CircularProgress size={"12px"} /> : props.value}
      </Box>
      <Button
        disabled={
          props?.isDisabled || props?.isLoading || props.value >= props.max
        }
        onClick={handleIncrement}
        variant="contained"
        sx={{
          minWidth: "unset",
          width: "40px",
          height: "32px",
          borderRadius: "0 4px 4px 0",
          fontSize: "1.2rem",
          "&:hover": {
            outline: "none",
          },
          "&.Mui-disabled": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.getContrastText(theme.palette.primary.main),
            opacity: 0.5,
          },
          ...props?.slot?.increment?.sx,
        }}
      >
        +
      </Button>
    </Stack>
  );
}
